if (!window.drvRebuyUpsellBound) {
  window.drvRebuyUpsellBound = true;

  const init = (root) => {
    if (typeof Swiper === 'undefined') return;
    const scope = root && root.nodeType === 1 ? root : document;

    scope.querySelectorAll('.drv-rbu__slider').forEach((el) => {
      if (el.swiper) return;

      new Swiper(el, {
        grabCursor: true,
        watchOverflow: true,
        slidesPerView: 'auto',
        spaceBetween: 8,
        mousewheel: { forceToAxis: true, releaseOnEdges: false },
        breakpoints: {
          750: { spaceBetween: 12 },
        },
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) init(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
